import { Tabs, TabsProps } from "antd";
import {
  ChartColumn,
  FileText,
  IndianRupee,
  LayoutDashboard,
  Sparkles,
  Zap,
} from "lucide-react";
import styles from "./CampaignTabs.module.scss";

export type Tab =
  | "overview"
  | "brief"
  | "execution"
  | "reports"
  | "finance"
  | "ai-overview";

interface CampaignTabsProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
  briefCount?: number;
  executionCount?: number;
}

export function CampaignTabs({
  activeTab,
  onTabChange,
  briefCount = 0,
  executionCount = 0,
}: CampaignTabsProps) {
  const renderTabLabel = (
    icon: React.ReactNode,
    label: string,
    tabKey: Tab,
    count?: number
  ) => {
    const isActive = activeTab === tabKey;
    return (
      <span className={styles.tabLabel}>
        {icon} {label}
        {count !== undefined && (
          <span
            className={`${styles.countBadge} ${
              isActive ? styles.countBadgeActive : styles.countBadgeInactive
            }`}
          >
            {count}
          </span>
        )}
      </span>
    );
  };

  const items: TabsProps["items"] = [
    {
      key: "overview",
      label: renderTabLabel(
        <LayoutDashboard size={16} />,
        "Overview",
        "overview"
      ),
    },
    {
      key: "brief",
      label: renderTabLabel(
        <FileText size={16} />,
        "In Brief",
        "brief",
        briefCount
      ),
    },
    {
      key: "execution",
      label: renderTabLabel(
        <Zap size={16} />,
        "In Execution",
        "execution",
        executionCount
      ),
    },
    {
      key: "reports",
      label: renderTabLabel(<ChartColumn size={16} />, "Reports", "reports"),
    },
    {
      key: "finance",
      label: renderTabLabel(<IndianRupee size={16} />, "Finance", "finance"),
    },
    {
      key: "ai-overview",
      label: renderTabLabel(
        <Sparkles size={16} />,
        "AI Settings",
        "ai-overview"
      ),
    },
  ];

  return (
    <div className={styles.tabsContainer}>
      <Tabs
        activeKey={activeTab}
        onChange={(key) => onTabChange(key as Tab)}
        items={items}
        className={styles.tabs}
      />
    </div>
  );
}
